export default function LoginWithGoogle({ redirectUrl }: { redirectUrl: string }) {
  const params = new URLSearchParams({
    corp: '1',
    redirectUrl,
  });
  const url = `/internal/login/google?${params.toString()}`;
  return (
    <a href={url} className="social-button google-button">
      <span className="social-button-icon google-icon"></span>
      <span className="social-button-text">LOG IN WITH GOOGLE</span>
    </a>
  );
}
